<template>
    <div class="full-height full-width row">
      <q-drawer
        v-model="state.left.show"
        :mini="!state.left.show || state.left.miniState"
        :width="220"
        :breakpoint="500"
        bordered
        content-class="bg-white column"
      >
        <q-scroll-area class="col">
          <q-list padding>
            <q-item v-show="state.left.miniState == false">
              <q-item-section>
                <q-item-label>Card OCR</q-item-label>
                <q-item-label caption style="padding-bottom:8px">
                  특정 문서 도메인에 맞춰서 설계된 OCR 솔루션 입니다. <br />
                  문서의 주요 내용을 key와 value로 짝을 맞춰 추출합니다.
                </q-item-label>
              </q-item-section>
            </q-item>
            <q-separator v-show="state.left.miniState == false" />
            <q-item dense v-show="state.left.miniState == false">
              <q-item-section>
                <q-item-label caption>
                  테스트
                </q-item-label>
              </q-item-section>
            </q-item>
            <q-item v-for="(view, i) in views" :key="`qitem-${i}`"
              :active="state.page.value == view.value" clickable v-ripple @click="state.page.value = view.value"
            >
              <q-item-section avatar>
                <q-icon :name="view.icon" />
              </q-item-section>
  
              <q-item-section>
                {{ view.name }}
              </q-item-section>
  
              <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">{{ view.name }}</q-tooltip>
            </q-item>
          </q-list>
        </q-scroll-area>
        <q-separator />
        <q-item clickable v-ripple @click="state.left.miniState = !state.left.miniState">
          <q-item-section avatar>
            <q-icon v-if="state.left.miniState == false" name="chevron_left" />
            <q-icon v-else name="chevron_right" />
          </q-item-section>
  
          <q-item-section style="color:rgb(125, 125, 125);font-size:12px;">
            POWERED BY SELVAS AI
          </q-item-section>
        </q-item>
      </q-drawer>
  
      <q-page-container class="column col full-height full-width">
        <q-page class="column col full-height full-width" style="background:rgb(237, 238, 242);overflow:auto;">
          <template v-for="(view, i) in views">
            <component
              v-if="state.page.value == view.value" :key="`template-${i}`" :is="view.componentName"
              :ref="view.value"
            >
            </component>
          </template>
        </q-page>
      </q-page-container>
    </div>
  </template>
  
  <script>
  /* eslint-disable vue/no-unused-components */
  
  import PassportView from '@/projects/card/views/PassportView.vue'  
  import IdcardView from '@/projects/card/views/IdcardView.vue'  
  import CreditcardView from '@/projects/card/views/CreditcardView.vue'
  
  export default {
    name: 'App',
    data: function () {
      return {
        state: {
          left: {
            show: true,
            miniState: false
          },
          page: {
            value: 'passport-view'
          }
        },
        views: [
          {
            'name': '여권',
            'value': 'passport-view',
            'icon': 'travel_explore',
            'componentName': PassportView
          },
          {
            // 'name': '신분증인식(2022)',
            'name': '신분증인식',
            'value': 'idcard-view',
            'icon': 'badge',
            'componentName': IdcardView
          },
          {
            // 'name': '신용카드인식(2022)',
            'name': '신용카드인식',
            'value': 'creditcard-view',
            'icon': 'credit_card',
            'componentName': CreditcardView
          }
        ]
      }
    },
    components: {
      PassportView,
      IdcardView,
      CreditcardView,
    },
    methods: {
    },
    mounted () {
  
    }
  }
  </script>
  
  <style>
  #app {
    position: relative;
    width: 100%;
    height: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    padding: 0;
    margin: 0;
    overflow: auto;
    background: rgb(239, 239, 239);
  }
  
  .body {
    display:flex;
    flex-direction:column;
    height:100%;
    width:100%;
    background: rgb(237, 238, 241);
  }
  
  .q-toggle__thumb {
    color: red !important;
  }
  
  .q-toggle__thumb:after {
    background: rgb(230, 230, 230) !important;
  }
  
  .q-toggle__inner--indet .q-toggle__thumb:after {
    background: rgb(3, 169, 244) !important;
  }
  
  .q-toggle__inner--truthy .q-toggle__thumb:after {
    background: #027BE3 !important;
  }
  
  .q-toggle__inner.q-toggle__inner--indet {
    color:rgb(41, 182, 246);
  }
  
  ::-webkit-scrollbar-track
  {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      border-radius: 10px;
      background-color: #F5F5F5;
  }
  
  ::-webkit-scrollbar
  {
      width: 6px;
    height: 6px;
      background-color: #F5F5F5;
  }
  
  ::-webkit-scrollbar-thumb
  {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
      background-color: #555;
  }
  
  </style>
  